export enum RefundRequestWizardStepIds {
  ResourceType = 'resourceType',
  SelectPolicy = 'selectPolicy',
  ItemSource = 'itemSource',
  CatalogForm = 'catalogForm',
  ExternalResourceType = 'externalResourceType',
  ExternalItemForm = 'externalItemForm',
  Summary = 'summary',
}
